import React from 'react';
import styles from './UIGameChatContainer.module.scss';
import clsx from 'clsx';
import IconArrowUp from '@static/images/icon_arrow_up_black.svg';
export function UIGameChatContainer({ children, isMinimized, setIsMinimized, minimizedTitle, showMinimizedNotification, backgroundColor }) {
    const setIsMinimizedWrapper = (state)=>{
        if (setIsMinimized) setIsMinimized(state);
    };
    if (isMinimized) {
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.container, styles[backgroundColor])
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.minimized,
            "data-testid": "chat-minimize-toggle",
            onClick: ()=>setIsMinimizedWrapper(false)
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.minimizedTitle
        }, minimizedTitle, showMinimizedNotification === true && /*#__PURE__*/ React.createElement("span", {
            className: styles.minimizedRedDot
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.chatMinimizeButton
        }, /*#__PURE__*/ React.createElement("img", {
            src: IconArrowUp
        }))));
    } else {
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.container, styles.maximized, styles[backgroundColor])
        }, children);
    }
}
